import { atom } from 'recoil'
import { ENVIRONMENT_CONFIG } from '../environmentOptions'

export const tokenAtom = atom({ key: ENVIRONMENT_CONFIG.TOKEN_NAME, default: '' }) // TODO storage
